

















































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney } from '@/utils/common'
import ModalProcedimentosIncluir from './ModalProcedimentosIncluir.vue'

@Component({
  components: {
    ModalProcedimentosIncluir,
  },
})
export default class ProcedimentosDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadProcedimentos: boolean = false
  get loadingProcedimentos() { return this.loadProcedimentos }
  set loadingProcedimentos(value: boolean) { this.loadProcedimentos = value }

  get procedimentosHeader() {
    return [
      { text: 'Incluído por', value: 'createdByNome', sortable: false, align: 'center' },
      { text: 'Incluído em', value: 'createdOn', sortable: false, align: 'center' },
      { text: 'Código procedimento', value: 'codigoProcedimento', sortable: false, align: 'center' },
      { text: 'Descrição procedimento', value: 'descricaoProcedimento', sortable: false, align: 'center' },
      { text: 'Valor garantia', value: 'valorGarantiaMinima', sortable: false, align: 'center' },
      { text: 'Ações', value: '', sortable: false, align: 'center' },
    ]
  }

  get procedimentos() { return this.getRegrasDeCalculoStore.procedimentos }
  get paginacaoProcedimentos() { return this.getRegrasDeCalculoStore.paginacaoProcedimentos }
  procedimentosDebounce = _.debounce(param => this.getRegrasDeCalculoStore.getProcedimentosAll(param), 700)

  async updatePaginationProcedimentos(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingProcedimentos = true
    this.procedimentosDebounce(pagination)
    this.loadingProcedimentos = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  formatMoneyUtil(value: any) {
    return maskMoney(value)
  }

  loadDeletarProcedimento: string = ''
  get loadingDeletarProcedimento() { return this.loadDeletarProcedimento }
  set loadingDeletarProcedimento(value: string) { this.loadDeletarProcedimento = value }

  get showModalProcedimentos() { return this.getRegrasDeCalculoStore.modal.procedimentos }
  set showModalProcedimentos(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'procedimentos', value }) }

  async removeProcedimento(procedimentoId: string) {
    this.loadingDeletarProcedimento = procedimentoId
    const request = await this.getRegrasDeCalculoStore.removeProcedimento(procedimentoId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarProcedimento = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarProcedimento = ''
  }
}
